// JSON-LD for the `support_mainnet` surface — the landing page that
// pitches the mainnet launch and accepts contributions.
//
// Schema choice: WebPage + DonateAction. `DonateAction` is the
// Schema.org-recommended type for crowdfunding / contribution flows.

import type { ShareSurface } from '@/lib/share/events';

import { organizationId, websiteId } from './site';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildSupportMainnetJsonLd(
  _surface: Extract<ShareSurface, { kind: 'support_mainnet' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  const name = ctx.name ?? 'Support Morfi mainnet';
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${ctx.pageUrl}#webpage`,
      url: ctx.pageUrl,
      name,
      ...(ctx.description !== undefined ? { description: ctx.description } : {}),
      primaryImageOfPage: { '@type': 'ImageObject', url: ctx.ogImageUrl },
      isPartOf: { '@id': websiteId() },
      publisher: { '@id': organizationId() },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'DonateAction',
      name,
      target: ctx.pageUrl,
      recipient: { '@id': organizationId() },
      image: ctx.ogImageUrl,
    },
  ];
}
